"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PivotTransform_1 = require("./PivotTransform");
var CollectionTransform_1 = require("./CollectionTransform");
var AliasTransform_1 = require("./AliasTransform");
var CaseTransform_1 = require("./CaseTransform");
var SplitTransform_1 = require("./SplitTransform");
var FilterTransform_1 = require("./FilterTransform");
var ConditionalTransform_1 = require("./ConditionalTransform");
var SwitchTransform_1 = require("./SwitchTransform");
var NumberTransform_1 = require("./NumberTransform");
var VisibleTransform_1 = require("./VisibleTransform");
var TrimTransform_1 = require("./TrimTransform");
var RenameFieldTransform_1 = require("./RenameFieldTransform");
var ObjectTransform_1 = require("./ObjectTransform");
var QueryTransform_1 = require("./QueryTransform");
var MapTransform_1 = require("./MapTransform");
var FormatTransform_1 = require("./FormatTransform");
var GroupTransform_1 = require("./GroupTransform");
var RegexTransform_1 = require("./RegexTransform");
var ReplaceTransform_1 = require("./ReplaceTransform");
var ParseTransform_1 = require("./ParseTransform");
var AggregateTransform_1 = require("./AggregateTransform");
var SortTransform_1 = require("./SortTransform");
var Transform = /** @class */ (function () {
    function Transform(options, translationHelper, callStackLevel) {
        this.options = options;
        this.translationHelper = translationHelper;
        this.callStackLevel = callStackLevel;
    }
    Transform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var transformOptionsType = this.options.transformOptionsType;
        var transform;
        if (transformOptionsType) {
            switch (transformOptionsType) {
                case 'pivot':
                    transform = new PivotTransform_1.PivotTransform(this.options, this.translationHelper);
                    break;
                case 'collection':
                    transform = new CollectionTransform_1.CollectionTransform(this.options, this.translationHelper);
                    break;
                case 'alias':
                    transform = new AliasTransform_1.AliasTransform(this.options, this.translationHelper);
                    break;
                case 'case':
                    transform = new CaseTransform_1.CaseTransform(this.options, this.translationHelper);
                    break;
                case 'split':
                    transform = new SplitTransform_1.SplitTransform(this.options, this.translationHelper);
                    break;
                case 'filter':
                    transform = new FilterTransform_1.FilterTransform(this.options, this.translationHelper);
                    break;
                case 'aggregate':
                    transform = new AggregateTransform_1.AggregateTransform(this.options, this.translationHelper);
                    break;
                case 'conditional':
                    transform = new ConditionalTransform_1.ConditionalTransform(this.options, this.translationHelper);
                    break;
                case 'switch':
                    transform = new SwitchTransform_1.SwitchTransform(this.options, this.translationHelper);
                    break;
                case 'number':
                    transform = new NumberTransform_1.NumberTransform(this.options, this.translationHelper);
                    break;
                case 'visible':
                    transform = new VisibleTransform_1.VisibleTransform(this.options, this.translationHelper);
                    break;
                case 'trim':
                    transform = new TrimTransform_1.TrimTransform(this.options, this.translationHelper);
                    break;
                case 'renameField':
                    transform = new RenameFieldTransform_1.RenameFieldTransform(this.options, this.translationHelper);
                    break;
                case 'object':
                    transform = new ObjectTransform_1.ObjectTransform(this.options, this.translationHelper, this.callStackLevel);
                    break;
                case 'query':
                    transform = new QueryTransform_1.QueryTransform(this.options, this.translationHelper, this.callStackLevel);
                    break;
                case 'map':
                    transform = new MapTransform_1.MapTransform(this.options, this.translationHelper, this.callStackLevel);
                    break;
                case 'format':
                    transform = new FormatTransform_1.FormatTransform(this.options, this.translationHelper, this.callStackLevel);
                    break;
                case 'group':
                    transform = new GroupTransform_1.GroupTransform(this.options, this.translationHelper);
                    break;
                case 'regex':
                    transform = new RegexTransform_1.RegexTransform(this.options, this.translationHelper);
                    break;
                case 'replace':
                    transform = new ReplaceTransform_1.ReplaceTransform(this.options, this.translationHelper);
                    break;
                case 'parse':
                    transform = new ParseTransform_1.ParseTransform(this.options, this.translationHelper);
                    break;
                case 'sort':
                    transform = new SortTransform_1.SortTransform(this.options, this.translationHelper);
                    break;
                default:
                    transform = undefined;
                    break;
            }
            if (transform) {
                var transformResponse = transform.execute(queryResponse, queryOptions, executionOptions);
                return transformResponse;
            }
        }
    };
    return Transform;
}());
exports.Transform = Transform;
//# sourceMappingURL=Transform.js.map